<header>
    <div class="header" style="display:block">
        <h1> {{header}} </h1>
    </div>
</header>

<div style="position: relative;">
    <form [formGroup]="addEditForm" (ngSubmit)="submitForm()">
        <div class="formbody" fxLayout="row wrap" fxLayoutGap="15px grid">
            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">LP</label></div>
                <div style="margin:10px">
                    <div>
                        <div>
                            <input formControlName="lp" type="text" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && addEditForm.get('lp')?.errors }"
                                readonly>
                        </div>
                    </div>

                   
                </div>
            </div>
          
           
            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">Run</label></div>
                <div style="margin:10px">
                    <div>
                        <div>
                            <input formControlName="MROSTrailer" type="text" class="form-control" maxlength='4'
                                [ngClass]="{ 'is-invalid': submitted && addEditForm.get('MROSTrailer')?.errors }"
                                (keypress)="validateRun($event)" (keyup)="updateValues($event)">
                        </div>
                    </div>

                    <div style="min-height:10px;">
                        <span *ngIf="submitted && addEditForm.get('MROSTrailer')?.errors" class="error-message">Run
                            is
                            Required</span>
                    </div>
                </div>
            </div>
            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">Short Desc</label></div>
                <div style="margin:10px">
                    <div>
                        <div>
                            <input formControlName="shortDescription" type="text" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && addEditForm.get('shortDescription')?.errors}"
                                maxlength="30" readonly>
                        </div>

                    </div>

                  
                </div>
            </div>
            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">Description</label></div>
                <div style="margin:10px">
                    <div>
                        <div>
                            <input formControlName="description" type="text" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && addEditForm.get('description')?.errors}"
                                maxlength="30" readonly>
                        </div>

                    </div>

                </div>
            </div>
            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
                <div style="margin:10px;width: 92px;"> <label for="route">Pallet Code</label></div>
                <div style="margin:10px">
                    <div>
                        <div>
                            <input formControlName="palletCode" type="text" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && addEditForm.get('palletCode')?.errors}"
                                maxlength="30" readonly/>
                        </div>

                    </div>

                   
                </div>
            </div>
           
            <div fxFlex="100%">
                <app-notification-message [errorMessage]="errorMessage"></app-notification-message>
            </div>
        </div>


        <div class="footerp cfooter">
            <label class="cancel" style="position: relative;
                right: 27px;" (click)="onNoClick()"> CANCEL
            </label>
            <button mat-raised-button class="submit" type="submit"
                style="display: inline;margin-right: 4%;">SAVE</button>
        </div>
    </form>
</div>